/* eslint-disable max-len */
/* eslint-disable no-mixed-spaces-and-tabs */
import { useSelector } from 'react-redux';
import { catchErr } from '../../../libs/HelperContent';
import { BookSeats } from '../../actions/training_actions';
import { toast } from 'react-toastify';

const useJoinReqSeat = () =>
{
	const session = useSelector((state:any) => state?.mysession?.session);

	const getJoinReqStatus = async (training,
		isSeatsAvailable, loading, setLoading,
		setCurrMeeting, bookSeat, getMeetingsList) =>
	{
		// if (!loading)
		// {
		if (new Date().valueOf() < (training?.startTime + training?.duration))
		{
			setLoading(true);
			const body = {
				id       : training?.id || training?.meetingId,
				type     : isSeatsAvailable ? 'book' : 'request',
				userData : {
					name         : `${session?.name || session?.firstName}`,
					userId       : session?.userId,
					companyName  : session?.companyName,
					email        : session?.email,
					country      : session?.presentAddress?.country || session?.workAddress?.country || '',
					companyId    : session?.companyId,
					profileImage : session?.profileImage || session?.thumbnailImage
				}

			};

			try
			{
				const res:any = await BookSeats(body);

				if (res?.status)
				{
					setLoading(false);
					if (isSeatsAvailable)
					{
						bookSeat.current = true;
						// setIsBooked({ open: true, type: 'booked' });
						toast.success(res?.message, {
							position : toast.POSITION.TOP_RIGHT
						});
						setCurrMeeting((prev:any) => ({ ...prev, booked: true }));
					}
					else
					{
						toast.success(res?.message, {
							position : toast.POSITION.TOP_RIGHT
						});
						// setIsRequested({ open: true, type: 'Requested' });

						return 'Requested';
					}

					return isSeatsAvailable ? 'booked' : 'requested';
				}
			}
			catch (err:any)
			{
			     	setLoading(false);
				catchErr(err);
				if (err && err?.response && err?.response?.data &&
						(err?.response?.data?.error === 'Sorry! Link Expired' || err?.response?.data?.error === 'Meeting Not Found Or Deleted' ||
						err?.response?.data?.error === 'You have already booked your seat.'))
				{
					bookSeat.current = true;
				}
				if (err?.response?.data?.error === 'Sorry! Link Expired') return 'expired';
				if (err?.response?.data?.error === 'You Already requested for this meeting') return 'already Requested';
			}
		}
		else
		{
			bookSeat.current = true;
			toast.error(!isSeatsAvailable ? 'You Already requested for this meeting' : 'Sorry! Link Expired', {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});

			return isSeatsAvailable ? 'expired' : 'already Requested';
		}
		// }
		getMeetingsList();
	};

	return getJoinReqStatus;
};

export default useJoinReqSeat;